import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "assets/scss/material-kit-react.css";
import ReactGA from "react-ga";

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKER_ID);

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js